module.exports = __webpack_public_path__ + "static/media/snappySearch.5c5226b5.svg";